<div id="nouislider-container" class="nouislider-container">
  <div class="slider-value" id="nouislider-label">
    {{ config?.label === "PriceGroup" ? "Price Range" : config?.label }}:
    <span *ngIf="config?.label === 'PriceGroup'">
      {{appcontext.currency?.symbol}}
    </span>
    <!-- config?.range?.min -->
      {{  config?.range?.min | number : "1.0-0" }}
      <span *ngIf="config?.label === 'Distance'">
        {{distanceUnit}}
      </span>
       -
       <span *ngIf="config?.label === 'PriceGroup'">
        {{appcontext.currency?.symbol}}
      </span>
      <!-- config?.range?.max -->
      {{ config?.range?.max | number : "1.0-0" }}
      <span *ngIf="config?.label === 'Distance'">
        {{distanceUnit}}
      </span>
  </div>
  <div class="slider-wrapper">
    <div #slider class="noUiSlider" id="nouislider-target"></div>
  </div>
  <div class="custom-min-max">
    <span class="custom-min">
      <span *ngIf="config?.label === 'PriceGroup'">
        {{
          appcontext.currency?.symbol
        }}
      </span>
      <input type="text" class="custom-price-range-input" id="range-min-input" [value]="selectedVals[0] | number : '1.0-0'" (input)="updateMin($event)" (change)="updateMinOnChange($event)" (focus)="onInputFocus($event)" (blur)="onInputBlur($event)" />
      <span *ngIf="config?.label === 'Distance'">
        {{ distanceUnit  }}
      </span>

    </span>
    <span class="custom-max">
      <span *ngIf="config?.label === 'PriceGroup'">
        {{
          appcontext.currency?.symbol
        }}
      </span>
      <input type="text" class="custom-price-range-input" id="range-max-input" [value]="selectedVals[1] | number : '1.0-0'" (input)="updateMax($event)" (change)="updateMaxOnChange($event)" (focus)="onInputFocus($event)" (blur)="onInputBlur($event)" />
      <span *ngIf="config?.label === 'Distance'">
        {{ distanceUnit  }}
      </span>
    </span>
  </div>
</div>
